/**
 * This is the messaging client helper for everybody feel free to use this class
 * The implementation will be the same implementation as the
 * old implementation in agoda.feMessaging.Measurement.js
 */

import { ILogMessage, IMeasurementMessage, IMeasurementTags } from '@agoda/messaging-client';
import defaultsDeep from 'lodash/defaultsDeep';
import { ActivitiesMessagingClient } from 'core/messaging/ActivitiesMessagingClient';
import { getBootstrapConfig } from 'core/window/windowService';

const feMessagingConfig = getBootstrapConfig().feMessagingConfig;

const DEFAULT_MEASUREMENT_CONFIG: IMeasurementMessage = {
    count: 1,
    measurement: 1,
    name: '',
    _meta: {
        type: 'measurement',
    },
    tags: {
        country: '_', // country is an origin of client
        device: '_',
        browser: '_',
        pagetype: feMessagingConfig.pageTypeId ? feMessagingConfig.pageTypeId.toString() : '0',
        dc: feMessagingConfig.dc,
        cluster: feMessagingConfig.cluster,
    },
};

const DEFAULT_LOG_CONFIG: ILogMessage = {
    level: 'info',
    message: 'log message',
    applicationName: 'www.agoda.com',
    sessionId: feMessagingConfig.sessionId,
    _meta: {
        type: 'log',
    },
};

const timestamp: () => number = typeof performance !== 'undefined' && performance.now ? () => Math.round(performance.now()) : () => +new Date();

const addDefaultTags = (measurement: IMeasurementMessage, tags: IMeasurementTags): IMeasurementMessage => {
    measurement.tags = defaultsDeep(measurement.tags, tags) as IMeasurementTags;
    const message: IMeasurementMessage = defaultsDeep(measurement, DEFAULT_MEASUREMENT_CONFIG) as IMeasurementMessage;
    return message;
};

const feMessagingMeasurement = {
    measureWithConfig(measurement: IMeasurementMessage, tags: IMeasurementTags): void {
        const finalMsg = addDefaultTags(measurement, tags);
        const msg = ActivitiesMessagingClient.create('measurement', finalMsg);
        ActivitiesMessagingClient.send(msg);
    },

    measure(name: string, measurement: number, tags: IMeasurementTags): void {
        this.measureWithConfig({ name, measurement } as IMeasurementMessage, tags);
    },

    count(name: string, tags: IMeasurementTags = {}): void {
        this.measure(name, 1, tags);
    },

    start(): number {
        return timestamp();
    },

    finish(name: string, started: number, tags: IMeasurementTags = {}): void {
        const finished = timestamp();
        const timeTaken = Math.round(finished - started);
        this.measure(name, timeTaken, tags);
    },
};

const feLoggingMeasurement = {
    logWithConfig(logMessage: ILogMessage, additional?: ILogMessage): void {
        const finalLogMessage: ILogMessage = defaultsDeep(logMessage, DEFAULT_LOG_CONFIG) as ILogMessage;
        const msg = ActivitiesMessagingClient.create('log', finalLogMessage);
        ActivitiesMessagingClient.send(msg);
    },

    log(message: ILogMessage): void {
        this.logWithConfig(message);
    },
};

export { feMessagingMeasurement, feLoggingMeasurement };
